import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { TestType } from '@risksmart-app/domain/src/types/consts/test-type';
import type { UpdateControlTestInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateControlTestInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateControlTestInternalAuditResultInput = {
  Id: string;
  OriginalTimestamp: string;
  ParentControlId: string;
  Title?: string | null;
  TestType?: TestType | null;
  Description?: string | null;
  DesignEffectiveness?: number | null;
  PerformanceEffectiveness?: number | null;
  OverallEffectiveness?: number | null;
  Submitter: string;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateControlTestInternalAuditResult = createMutationHook({
  name: 'updateControlTestInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.updateControlTest.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateControlTestInternalAuditResultInput) => input,
  mapResponse: (result: {
    Id: string;
  }): UpdateControlTestInternalAuditResultMutation => ({
    updateControlTestInternalAuditResultApi: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
    // COI-471 parity: Apollo twin also evicts `control`.
    trpc.frontend.control.pathKey(),
  ],
  graphqlDocument: UpdateControlTestInternalAuditResultDocument,
  graphqlVariables: (input: UpdateControlTestInternalAuditResultInput) => ({
    object: input,
  }),
  evictFields: [
    'control_test_internal_audit_result',
    'control',
    'internal_audit_report',
  ],
});
